/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import messages from 'services/locales/en/messages';
import { SongType } from '../entities';
import {
  AudioDownloadRendering,
  AudioDownloadRenderingStatus,
} from '../entities/audioDownloadRendering';
import {
  BaseSongResponse,
  SongDownloadResponse,
  StudioSongListResponse,
  ErrorResponse,
  DownloadLimitErrorData,
  AudioDownloadRenderingStatusResponse,
} from '../responses/responseTypes';

export const transformToStudioSong = (song: BaseSongResponse) => ({
  songType: SongType.STUDIO,
  id: song.id,
  title: song.title,
  duration: song.duration,
  isInLibrary: song.is_in_library,
  musicFilePath: song.music_file_path,
  wavFilePath: song.wav_file_path,
});

export const transformToPaginatedList = ({
  pagination_data,
  ...data
}: StudioSongListResponse) => ({
  songs: data.items.map((song) => transformToStudioSong(song)),
  areAllPagesLoaded:
    pagination_data.total_pages === pagination_data.current_page,
});

export const tranformToSongDownloadInfo = ({
  download_data: { download_limit, ...data },
}: SongDownloadResponse) => ({
  ...data,
  ...(download_limit && {
    downloadLimit: {
      isWarning: download_limit.is_warning,
      remainingDownloads: download_limit.downloads_available_today,
      daysToDownloadLimitReset: download_limit.days_to_limit_reset,
    },
  }),
});

export const transformToDownloadRenderingData = ({
  status,
  payload,
}: AudioDownloadRenderingStatusResponse): AudioDownloadRendering =>
  status === AudioDownloadRenderingStatus.Finished
    ? { status: AudioDownloadRenderingStatus.Finished, downloadUrl: payload }
    : { status: AudioDownloadRenderingStatus.Processing, message: payload };

export const transformToDownloadLimitError = (
  response: ErrorResponse<DownloadLimitErrorData>
) => {
  const { data } = response;

  if (!data) {
    return { message: messages.error.unknown };
  }

  const { payload } = data;
  if (!payload) {
    return { message: response.data.error_description };
  }

  const { exception_code, days_to_limit_reset } = payload;
  if (exception_code) {
    const daysToReset = days_to_limit_reset ?? 0;
    return {
      code: exception_code,
      message: response.data.error_description,
      daysToReset,
    };
  }

  return { message: messages.error.unknown };
};
